import { useState } from 'react';
import './filtersGrid.scss';

const FiltersGrid = ({ setSearchFilter }) => {
  const [searchValue, setSearchValue] = useState('');

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);

    // Debounce de 300ms
    clearTimeout(window.searchTimeout);
    window.searchTimeout = setTimeout(() => {
      setSearchFilter(value);
    }, 300);
  };

  const handleClear = () => {
    setSearchValue('');
    setSearchFilter('');
  };

  return (
    <div className="filtersGrid">
      <div className="filtersGrid__search">
        <input
          type="text"
          placeholder="Buscar cliente..."
          value={searchValue}
          onChange={handleSearch}
          className="filtersGrid__input"
        />
        {searchValue && (
          <button
            type="button"
            className="filtersGrid__clear"
            onClick={handleClear}
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default FiltersGrid;
